import React from "react";

export type FeatureFlagEnvs = "development" | "production" | "test";

const FeaturesToggleContext = React.createContext({
    enabledFeatures: [] as string[]
});

export default FeaturesToggleContext;